import axios from 'axios';
import useTokenStore from '../store/useTokenStore';

const axiosInstance = axios.create();

axiosInstance.interceptors.request.use(
    (config) => {
        const token = useTokenStore.getState().token;
        if (token) config.headers['Authorization'] = `Bearer ${token}`;

        return config;
    }
);

axiosInstance.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        if (error.response && error.response.data && error.response.data.error_code) {
            if (error.response.data.error_code === 4003) {
                const clearToken = useTokenStore.getState().clearToken;
                clearToken();
                window.location.reload();
            }
        }
        return Promise.reject(error);
    }
);

export default axiosInstance;